import script from "./MaterialDelivery.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialDelivery.vue?vue&type=script&setup=true&lang=js"

import "./MaterialDelivery.vue?vue&type=style&index=0&id=020a460f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-020a460f"]])

export default __exports__